import { useRef } from 'react';

// material-ui
import { Box } from '@mui/material';

// project import
import IconButton from 'components/@extended/IconButton';
import { HEADER_ICON_BUTTON_SX, HEADER_ICON_SLOT_SX } from 'components/ui/tokens';

// assets
import settingsIcon from 'assets/images/icons/header/settings.svg';
import { useNavigate } from 'react-router';

// ==============================|| HEADER CONTENT - SETTINGS ||============================== //

const Settings = () => {
  const anchorRef = useRef<any>(null);
  const navigate = useNavigate();

  return (
    <Box sx={HEADER_ICON_SLOT_SX}>
      <IconButton
        color="secondary"
        sx={HEADER_ICON_BUTTON_SX}
        aria-label="settings"
        ref={anchorRef}
        onClick={() => navigate('/account-settings')}
      >
        <img src={settingsIcon} alt="settings" style={{ width: 18, height: 18 }} />
      </IconButton>
    </Box>
  );
};

export default Settings;
